import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import slugify from 'slugify'

import { fetchReport } from 'ducks/reportAdvert';
import { fetchReasons } from 'ducks/reportAdvertReasons';

import { getCookieChannel, onClientSide } from 'utils/utils';
import { SYSTEM, CHANNEL_REPORT, VEHICLE_TYPE, VEHICLE_TYPE_ENUM, COOKIES, COOKIE_NOTICE_TYPES } from 'utils/constants';

import { withCookieNotice } from '@/store/context/cookie-notice-context'

import { cookieCategoryIsActive } from '@/modern/utils/cookies'
import { config } from 'config/config'

import Checkbox from '@/modern/components/Checkbox'
import Button from 'components/Button';
import Input from 'components/Input';
import PlaceHolder from 'components/PlaceHolder';
import FormDetails from '.';
import { withTracking } from '@/modern/tracking/global/hooks/useTracking';
import createTrackingData from '@/modern/tracking/global/helpers/createTrackingData';
import { DATALAYER_PAGES } from '@/modern/tracking/pages';

class ReportAdvert extends Component {
	constructor(props) {
		super(props);

		const { cookieNoticeContext, dispatchAnalyticsEvent } = this.props
		const { cookies } = cookieNoticeContext

		this.dispatchAnalyticsEvent = dispatchAnalyticsEvent

		this.cookiesState = {
			channel: cookieCategoryIsActive(cookies, COOKIES.CHANNEL),
		}

		this.state = {
			showFormErrors: true,
			fullName: '',
			fullNameError: true,
			email: '',
			emailError: true,
			message: '',
			messageError: true,
			reason: '',
			reasons: [],
			reasonError: true,
			success: false,
			allowSharing: false,
			messageDetails: {
				charCount: 0,
				inputChanged: false,
			}
		}
		this.handleChangeInputs = this.handleChangeInputs.bind(this)
		this.sendReportAdvert = this.sendReportAdvert.bind(this)
		this.handleBlur = this.handleBlur.bind(this)
	}

	componentDidMount() {
		if (!this.props.reportAdvertReasons.fetched) {
			this.props.dispatch(fetchReasons()).then(() => {
				this.setReasons();
			});
		} else {
			this.setReasons();
		}
	}

	setReasons() {
		if (this.props.reportAdvertReasons.fetched && this.props.reportAdvertReasons.result && this.props.reportAdvertReasons.result.length > 0) {
			this.setState({ reasons: this.props.reportAdvertReasons.result });
		}
	}

	handleChangeInputs(e) {
		const { name, value } = e.target

		const newState = { [name]: value }

		if (name === 'message') {
			const charCount = (value.match(/[^\s\n\r]/g) || []).length;
			newState.messageDetails = {
				...this.state.messageDetails,
				charCount,
				inputChanged: true,
			}
		}

		this.setState(newState)
    }

	formValidation = (error, name) => {
		if (name === 'message') {
			error = this.state.messageDetails.charCount < 29
		}

		this.setState({ [name + "Error"]: error }, () => {
			this.setState({
				showFormErrors: !this.state.emailError && !this.state.fullNameError && !this.state.reasonError
					&& !this.state.messageError ? false : true
			})
		})
	}
	getInputClassName() {
		const { charCount, inputChanged } = this.state.messageDetails;
		return `Form__field--message ${
			inputChanged && charCount < 30 ? 'Form__field--invalid Form__field--blurred' : ''
		}`;
	}

	sendReportAdvert() {
		const { fullName, email, reason, message } = this.state
		const { vehicleType, uniqueId } = this.props.dataForm

		let _cookieChannel = this.cookiesState.channel && getCookieChannel()
		let _channel = CHANNEL_REPORT.SITE
		if (_cookieChannel) {
			if (_cookieChannel == SYSTEM.MEUCARANGO)
				_channel = CHANNEL_REPORT.MEUCARANGO
			else if (_cookieChannel == SYSTEM.COMPREAUTO)
				_channel = CHANNEL_REPORT.COMPREAUTO
		}


		if (!this.state.showFormErrors && this.state.allowSharing) {
			const _data = {
				vehicleType: vehicleType == VEHICLE_TYPE.car ? VEHICLE_TYPE_ENUM.CAR : VEHICLE_TYPE_ENUM.BIKE,
				idAdvertise: uniqueId,
				name: fullName.trim(),
				email: email.trim(),
				description: message.trim(),
				channel: _channel,
				reportTypeId: parseInt(reason),

			};
			if (onClientSide()) {
				const customObjDatalayer = {
					complaint: {
						id: undefined,
						description: _data.reportTypeId
					}
				}
				const trackingData = createTrackingData('envioDenuncia', DATALAYER_PAGES.adDetail, customObjDatalayer)
				this.dispatchAnalyticsEvent(trackingData)
				this.props.dispatch(fetchReport(_data)).then(() => {
					this.handleReportSuccess();
				});
			}
		}

	}
	handleReportSuccess() {
		const { uniqueId } = this.props.dataForm
    const reportsData = JSON.parse(localStorage.getItem(config.adReports)) || {}

    if (!reportsData[uniqueId]) reportsData[uniqueId] = 1
    else reportsData[uniqueId]++

    localStorage.setItem(config.adReports, JSON.stringify(reportsData))
    this.setState({ success: true })
	}
	onChange(e) {
		let _reason = this.refs.reportAdvert.value;
		if (_reason == 0) {
			this.formValidation(true, 'reason')
		}
		else {
			this.formValidation(false, 'reason')
			this.setState({ reason: _reason })
		}

	}
	handleBlur(e) {
		const { name } = e.target;
		if (name === 'message') {
			this.setState(prevState => ({
				messageDetails: {
					...prevState.messageDetails,
					inputChanged: true,
				},
			}));
		}
	}


	renderReportAdvert() {
		return (
			<FormDetails className={'Forms--report-advert'} id={'ReportAdvert'}>
				<div className='Forms--report-advert__top'>
					<h2 className='Forms--report-advert__top__title'>Denunciar anúncio</h2>
					<p className='Forms--report-advert__top__description'>Este anúncio tem irregularidades? <br /> Conta pra gente!</p>
					<span className='Forms--report-advert__top__required'>*Campos obrigatórios</span>
				</div>
				<form autoComplete='off' className="Forms--report-advert__middle">
					<Input
						type={"text"}
						showErrors={this.state.fullNameError}
						formValidation={this.formValidation}
						className={"Form__field--name"}
						name={"fullName"}
						label={"Nome*"}
						onChange={this.handleChangeInputs}
						value={this.state.fullName}
						regex={"surname"}
						required={{ minChars: 3 }}
					/>
					<Input
						type={"email"}
						showErrors={this.state.emailError}
						formValidation={this.formValidation}
						name={"email"}
						label={"E-mail*"}
						className={"Form__field--email"}
						onChange={this.handleChangeInputs}
						value={this.state.email}
						regex={"email"}
						required={{ minChars: 3, maxChars: 150 }}
					/>

					<div className={'Form__field Form__field--select'}>
						<select id="ReasonReportAdvert" className="reason-report-advert" value={this.state.reason != undefined ? this.state.reason : <PlaceHolder />} onChange={this.onChange.bind(this)} ref='reportAdvert' required aria-required="true">
							{
								this.state.reasons && this.state.reasons.length > 0 ?
								[{id: "", name: "Qual motivo?"}].concat(this.state.reasons).map((el) => { return <option value={el.id} key={slugify(el.name)}>{el.name}</option> })
									:
									<option value="" id="ReasonReportAdvertSelectReason">Carregando...</option>
							}
						</select>
					</div>
					<Input
						type="text"
						showErrors={this.state.messageError}
						formValidation={this.formValidation}
						name="message"
						placeholder="Descreva com detalhes a sua denúncia (mínimo 30 caracteres)*"
						className={`${this.getInputClassName()}`}
						onBlur={this.handleBlur}
						value={this.state.message}
						regex={"messageReport"}
						onChange={this.handleChangeInputs}
						required={{ minChars: 29 }}
					/>
					<Checkbox
						checked={this.state.allowSharing}
						id="check-complaint"
						text="Autorizo que a Webmotors compartilhe meus dados com parceiros para resolver a questão.*"
						handleChange={() => this.setState({ allowSharing: !this.state.allowSharing })}
					/>
				</form>

				<div className='Forms--report-advert__bottom'>
					<Button
						className={` Button--send-report-advert customButtom ${this.state.showFormErrors || !this.state.allowSharing || this.state.messageDetails.charCount < 30 ? 'Button--disabled' : ''}`}
						name="ButtonSendReportAdvert"
						id="ButtonSendReportAdvert"
						value="ButtonSendReportAdvert"
						type="submit"
						onClick={this.sendReportAdvert}
					>
						Enviar
					</Button>
				</div>
			</FormDetails>
		)
	}
	renderReportAdvertSuccess() {
		return (
			<FormDetails className={'Forms--report-advert'} id={'ReportAdvert'}>
				<div className='Forms--report-advert__sucess'>
					<h2 className='Forms--report-advert__sucess__title'>Mensagem enviada <span>com sucesso!</span></h2>
					<p className='Forms--report-advert__sucess__description'>Sua indicação foi encaminhada à área responsável. Se necessário, entraremos em contato.</p>
					<strong className='Forms--report-advert__sucess__thank-you'>Obrigado por ajudar a Webmotors a coibir ações que possam prejudicar seus internautas. ;)</strong>
				</div>
			</FormDetails>
		)
	}
	render() {
		return (
			!this.state.success ?
				this.renderReportAdvert()
				: this.renderReportAdvertSuccess()
		)
	}
}
export default withCookieNotice(withRouter(connect((store) => {
	return {
		reportAdvert: store.reportAdvertState,
		reportAdvertReasons: store.reportAdvertReasonsState
	}
})(withTracking(ReportAdvert))));
